import { render, staticRenderFns } from "./CardEquipe.vue?vue&type=template&id=45ec1c44&scoped=true&"
import script from "./CardEquipe.vue?vue&type=script&lang=js&"
export * from "./CardEquipe.vue?vue&type=script&lang=js&"
import style0 from "./CardEquipe.vue?vue&type=style&index=0&id=45ec1c44&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ec1c44",
  null
  
)

export default component.exports